import React from "react";

export default function Terms() {
  return (
    <div className="p-5">
      <p className="text-3xl">Terms, Conditions & Policies</p>
      <br />
      <p className="p-3">
        <ul className="list-disc">
          <li>
            We will be using your mobile number to identify you. We won&apos;t
            share your information to any third party app.
          </li>
          <li>
            Your information can be used to serve you with better ads and to
            improve the service, again no third party will access this.
          </li>
          <li>
            You agree to use cookies and third party services such as google
            maps, google analytics , firebase auth.
          </li>
          <li>
            {" "}
            Since this website is in beta, In case of data leakage, you agree
            not to take legal actions.
          </li>
          <li>
            You agree to see ads, since we dont charge money, we need ads to
            keep the website running.
          </li>
          <li>
            Using loophole of this service will be an illegal action, in case we
            find that you are misusing our service or exploting our service, we
            will be able to take legal action against you. Since it's free, dont
            hack and dont break freedom.
          </li>
        </ul>
      </p>
    </div>
  );
}
